module.exports = __webpack_public_path__ + "static/wolfram-652075d8a4d0088997b211d55b6abafa.png";